interface NotificationInstructionProps {
    label: string;
    text: string | null;
    // The table clamps to three lines and keeps the rest in a tooltip; the patient view shows it all.
    clamped?: boolean;
}

export function NotificationInstruction({
    label,
    text,
    clamped = false
}: NotificationInstructionProps) {
    if (!text) return null;
    return (
        <p
            className={`whitespace-pre-line break-words text-xs leading-5 text-gray-500 ${clamped ? 'line-clamp-3' : ''}`}
            title={clamped ? `${label} ${text}` : undefined}
        >
            <span className="font-medium text-gray-700">{label} </span>
            {text}
        </p>
    );
}
